import React from 'react';
import { dateDetailsPropTypes } from './DateDetailsPropTypes';
import Date from '@Theme/natucare/components/Tooltip/components/Date/Date';
import Hr from '@Theme/natucare/components/Tooltip/components/Hr/Hr';
import Text from '@Theme/natucare/components/Tooltip/components/Text/Text';
import * as styles from './DateDetails.module.scss';
const DateDetails = ({
  dates,
  footerText
}) => {
  if (!dates && !footerText) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rootDates
  }, dates.map(({
    label,
    datetime,
    date
  }, index) => date && /*#__PURE__*/React.createElement(Date, {
    label: label,
    datetime: datetime,
    date: date,
    key: index
  }))), footerText && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Hr, null), /*#__PURE__*/React.createElement(Text, {
    html: footerText
  })));
};
export default DateDetails;